/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Paridad con `.period` en multi-org-owner-panel-v1.html:
 * mobile — fila full-width, tres segmentos iguales; desktop — pills compactas en desk-top.
 */
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing';
import { ticketFonts } from '../../shared/theme/ticketColors';
import type { OwnerPanelPeriod } from '../domain/types';

const PERIODS: { id: OwnerPanelPeriod; label: string }[] = [
  { id: 'today', label: 'Hoy' },
  { id: 'week', label: 'Semana' },
  { id: 'month', label: 'Mes' },
];

export type OwnerPanelPeriodLayout = 'full' | 'compact';

type Props = {
  period: OwnerPanelPeriod;
  onPeriodChange: (period: OwnerPanelPeriod) => void;
  layout: OwnerPanelPeriodLayout;
};

export function OwnerPanelPeriodTabs({ period, onPeriodChange, layout }: Props) {
  const full = layout === 'full';

  return (
    <View
      style={[styles.row, full ? styles.rowFull : styles.rowCompact]}
      testID="owner-panel.period"
    >
      {PERIODS.map((p) => {
        const on = period === p.id;
        return (
          <Pressable
            key={p.id}
            style={[
              styles.btn,
              full ? styles.btnFull : styles.btnCompact,
              on && styles.btnOn,
            ]}
            onPress={() => onPeriodChange(p.id)}
            accessibilityRole="button"
            accessibilityState={{ selected: on }}
            testID={`owner-panel.period.${p.id}`}
          >
            <Text style={[styles.btnText, on && styles.btnTextOn]}>{p.label}</Text>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: 6,
  },
  rowFull: {
    alignSelf: 'stretch',
    width: '100%',
  },
  rowCompact: {
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'flex-end',
  },
  btn: {
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: spacing.sm,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 34,
  },
  btnFull: {
    flex: 1,
    minWidth: 0,
  },
  btnCompact: {
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 72,
    paddingHorizontal: 14,
    paddingVertical: 7,
    minHeight: 32,
  },
  btnOn: {
    backgroundColor: colors.accent,
    borderColor: colors.accent,
  },
  btnText: {
    fontFamily: ticketFonts.sans,
    fontWeight: '600',
    fontSize: 12,
    lineHeight: 12,
    color: colors.textSecondary,
  },
  btnTextOn: {
    color: '#FFFFFF',
  },
});
